/**
 * Faction component - identifies which faction an entity belongs to
 */

import type { FactionId } from '@/types';

export interface FactionComponent {
  factionId: FactionId;
}

export function createFaction(factionId: FactionId): FactionComponent {
  return { factionId };
}
